import { useCallback } from 'react';
import 'dayjs/locale/pt-br';
import { compareDatesDDMMYYYY } from '@monorepo-web/utils';
export const useIsDisabled = (obj_datas, config) => {
    var _a, _b;
    let compareDates = 0;
    let dateToCompare = null;
    if (!(config === null || config === void 0 ? void 0 : config.calendarioUnico)) {
        if ((config === null || config === void 0 ? void 0 : config.type) === 'ini') {
            compareDates = 1;
            dateToCompare = (_a = config === null || config === void 0 ? void 0 : config.datas) === null || _a === void 0 ? void 0 : _a.data_fim;
        }
        if ((config === null || config === void 0 ? void 0 : config.type) === 'fim') {
            compareDates = -1;
            dateToCompare = (_b = config === null || config === void 0 ? void 0 : config.datas) === null || _b === void 0 ? void 0 : _b.data_ini;
        }
    }
    const isDisabled = useCallback((date) => {
        var _a;
        const day = date.day();
        const dates = date.format('YYYY-MM-DD');
        const dateDDMMYYYY = date.format('DDMMYYYY');
        const dataTemp = new Date(dates);
        let dataLimiteMin = new Date('1999-01-01');
        let dataLimiteMax = new Date('2099-12-31');
        dataLimiteMin = new Date(obj_datas.data_mais_antiga_portfolio_AAAAmmDD);
        dataLimiteMax = new Date(obj_datas.data_mais_recente_portfolio_AAAAmmDD);
        return (day === 0 ||
            day === 6 ||
            ((_a = obj_datas.datas_nao_uteis) === null || _a === void 0 ? void 0 : _a.includes(dates)) ||
            dataTemp > dataLimiteMax ||
            dataTemp < dataLimiteMin ||
            (compareDates > 0 && compareDatesDDMMYYYY(dateToCompare, dateDDMMYYYY) <= 0) ||
            (compareDates < 0 && compareDatesDDMMYYYY(dateToCompare, dateDDMMYYYY) >= 0));
    }, [obj_datas, config]);
    return isDisabled;
};
